import { render, staticRenderFns } from "./RelationshipManage.vue?vue&type=template&id=398ddd46&"
import script from "./RelationshipManage.vue?vue&type=script&lang=js&"
export * from "./RelationshipManage.vue?vue&type=script&lang=js&"
import style0 from "./RelationshipManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports